import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { homeAPI } from '../../api/config';
import {
  fetchHomeDataSuccess,
  fetchHomeDataFailure
} from '../actions/homeActions';
import * as types from '../constants/actionTypes';

function* fetchHomeDataSaga() {
  try {
    const response = yield call(homeAPI.fetchHomeData);
    yield put(fetchHomeDataSuccess(response.data.data));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Failed to load dashboard data';
    yield put(fetchHomeDataFailure(errorMessage));
    message.error(errorMessage);
  }
}

function* watchHome() {
  yield takeEvery(types.FETCH_HOME_DATA_REQUEST, fetchHomeDataSaga);
}

export default watchHome;